<span class="user-type" [ngClass]="decipheredClass">
    {{type}}
</span>